namespace Areas.Ucop.List {
    "use strict";

    export function editLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.daUcopId; },
            "<a href= '/Ucop/Detail/Index/{placeholder}'>Edit</a>");
    }

    export function goBack() {
        location.href = '/UCOP/List/Index';
    }

    export function showCreate() {
        const createDaUcopDialog = new Areas.Dialogs.CreateDaUcopDialog(() => { });
    }

}